import React from 'react'
import {connect} from 'dva'
import {modelUtils, seatsOut} from '@/utils'
import {framework_tool, component_tool, utils_tool} from '@/tool'
import {QsPreview} from '@/components'

let {WizContainer} = framework_tool
let {WizSpin} = component_tool
let {Session} = utils_tool


class SurveyRecordInfoDetail extends WizContainer {

  componentName = 'surveyRecordInfoDetail'

  constructor(props) {
    super(props)
    let {record} = props
    this.record = record
    this.state = {
      surveyInfoDetail:{}
    }
  }

  componentDidMount() {
    if(this.record && this.record.id){
      this._getSurveyAnswerList({ids:[this.record.id]})
    }
  }

  _getSurveyAnswerList(apiParams = {}) {
    this.doAction(
      {
        path: 'surveyAnswer/surveyAnswerList',
        payload: {
          key: 'surveyAnswer@surveyAnswerList',
          apiParams: {
            ...apiParams
          }
        }
      }
    )
  }

  propsAndStateOnChange = {
    surveyAnswerList: this._surveyAnswerListOver.bind(this),
  }

  _surveyAnswerListOver(nextProps, nextState) {
    if (nextProps.surveyAnswerList.code === 1 && nextProps.surveyAnswerList.data && nextProps.surveyAnswerList.data.length) {
      nextState.surveyInfoDetail = nextProps.surveyAnswerList.data[0]
      return true;
    } else {
      wizNotice.error('获取问卷数据失败')
      return false;
    }
  }



  _render() {
    return (
      <WizSpin tip={'加载中'} spinning={this.props.surveyAnswerLoading }>
       <QsPreview data={{...this.state.surveyInfoDetail, preview: false}}/>
       </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { surveyAnswer } = state
  const surveyAnswerList = modelUtils.getModelEntity(surveyAnswer, "surveyAnswer@surveyAnswerList")

  const load = modelUtils.getLoadingState(state, ['surveyAnswer']);
  return {
    surveyAnswerList,
    ...load
  }
};

export default connect(mapStateToProps)(SurveyRecordInfoDetail);
